import { render, staticRenderFns } from "./ResendFailedEmail.vue?vue&type=template&id=6f214980&"
import script from "./ResendFailedEmail.vue?vue&type=script&lang=js&"
export * from "./ResendFailedEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f214980')) {
      api.createRecord('6f214980', component.options)
    } else {
      api.reload('6f214980', component.options)
    }
    module.hot.accept("./ResendFailedEmail.vue?vue&type=template&id=6f214980&", function () {
      api.rerender('6f214980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outputs/ResendFailedEmail.vue"
export default component.exports